// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"634a8bad","757":"839f24f8","821":"cd26ab03","978":"4dca8b8a"}[chunkId] + ".chunk.css";
};